import React from 'react';
import styled from 'styled-components';
import { Type, spacer16 } from '@spotify-internal/encore-web';

// import { useTranslation } from 'providers/translations/TranslationProvider';
import { IsHelpfulAnswerEnum } from 'experiments/feedback-position/hooks/useIsHelpfulAnswer';

import MessageUsButton from './MessageUsButton';

const StyledButtonContainer = styled.div`
  margin-top: ${spacer16};
`;

interface ThanksMessageProps {
  answered?: IsHelpfulAnswerEnum;
  trackMessageUsLink: () => void;
}

const ThanksMessage = ({ answered, trackMessageUsLink }: ThanksMessageProps) => {
  // const { t } = useTranslation();

  return (
    <div aria-live="polite">
      <Type as="p" variant="ballad">
        {/* {t('feedback_thanks_message')}*/}
        Thanks for your feedback!
      </Type>
      {answered === IsHelpfulAnswerEnum.no && (
        <StyledButtonContainer>
          <MessageUsButton trackMessageUsLink={trackMessageUsLink} />
        </StyledButtonContainer>
      )}
    </div>
  );
};

export default ThanksMessage;
